import React, { useEffect } from "react";
import EntryVideo from "../entryVideo/entryVideo";
import Intro from "../intro/intro";
import Transportations from "../transportations/transportations";
import WhyHK from "../whyHK/whyHK";
import ScrollSection from "../scrollSection/scrollSection";
import SpacerSection from "../spacerSection/spacerSection";
import Freight from "../Freight/freight";
import OurTeam from "../ourTeam/ourTeam";
import ContactUs from "../contactUs/contactUs";
import endImg from "../../images/end.png";

function HomePage() {
  useEffect(() => {
    const saved = sessionStorage.getItem("scroll_/");
    if (saved !== null) {
      sessionStorage.removeItem("scroll_/");
      const pos = parseInt(saved);
      const interval = setInterval(() => {
        if (document.body.scrollHeight >= pos) {
          window.scrollTo({ top: pos, behavior: "instant" });
          clearInterval(interval);
        }
      }, 50);
      setTimeout(() => clearInterval(interval), 3000);
    }
  }, []);

  return (
    <>
      <EntryVideo />
      <Intro />
      {/* <Transportations /> */}
      <WhyHK />
      <ScrollSection />
      <SpacerSection />
      <Freight />
      <img src={endImg} alt="" style={{ width: "100vw", height: "100vh", display: "block", objectFit: "cover" }} />
      <ContactUs />
    </>
  );
}

export default HomePage;
